import React from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { UPDATE_MOBILE_NUMBER } from 'src/services/individualService'
import { useMutation } from '@apollo/client'
import { useDispatch, useSelector } from 'react-redux'
import { showNotificationMessage, userinfo } from 'src/actions'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import {
  INVALID_NUMBER,
  NOTIFICATION_SETTINGS_MSG,
} from 'src/utils/constants/Individual'
import { FORMIK_VALIDATIONS } from 'src/utils/constants/Profile'

const ChangeMobileNumber = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const userInfo = useSelector((state) => state?.userInfo)
  const userId = userInfo?.userInfo?.userData?.userId

  const formik = useFormik({
    initialValues: {
      editedMobileNumber: props?.currentMobileNo,
      editedNewMobileNumber: '',
    },
    validationSchema: Yup.object({
      editedMobileNumber: Yup.string()
        .matches(/^[6789]\d{9}$/, INVALID_NUMBER)
        .required(FORMIK_VALIDATIONS?.REQUIRED),
      editedNewMobileNumber: Yup.string()
        .matches(/^[6789]\d{9}$/, INVALID_NUMBER)
        .required(FORMIK_VALIDATIONS?.REQUIRED),
    }),
    onSubmit: (values) => {
      props.setEditing(false)
      saveMobileNumber({
        variables: {
          updateMobileNumberRequest: {
            userId: userId,
            existingMobileNumber: values?.editedMobileNumber,
            newMobileNumber: values?.editedNewMobileNumber,
          },
        },
      })
    },
  })

  const [saveMobileNumber, { loading }] = useMutation(UPDATE_MOBILE_NUMBER(), {
    onCompleted: (data) => {
      if (data?.updateUserMobileNumber?.success) {
        const updatedProfile = {
          ...userInfo?.userInfo,
          userData: {
            ...userInfo?.userInfo?.userData,
            mobileNumber: formik?.values?.editedNewMobileNumber,
          },
        }
        dispatch(userinfo(updatedProfile))
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_SETTINGS_MSG?.MOBILE_NO_NOT_UPDATED,
          })
        )
      }
    },
  })

  const handleCancelClick = () => {
    props.setEditing(false)
  }

  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.headingContainer}>
          <span>Change Mobile Number</span>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.textFields}>
            <div>
              <TextField
                label='Old Mobile Number'
                id='oldMobileNumber'
                variant='outlined'
                type='number'
                value={formik?.values?.editedMobileNumber}
                {...formik.getFieldProps('editedMobileNumber')}
                error={
                  formik?.touched?.editedMobileNumber &&
                  Boolean(formik?.errors?.editedMobileNumber)
                }
                helperText={
                  formik?.touched?.editedMobileNumber &&
                  formik?.errors?.editedMobileNumber
                }
                className={classes.textField}
                InputProps={{
                  sx: {
                    borderColor: '#B92250 !important',
                  },
                }}
              />
            </div>
            <div>
              <TextField
                label='New Mobile Number'
                id='newMobileNumber'
                variant='outlined'
                type='number'
                value={formik?.values?.editedNewMobileNumber}
                {...formik.getFieldProps('editedNewMobileNumber')}
                error={
                  formik?.touched?.editedNewMobileNumber &&
                  Boolean(formik?.errors?.editedNewMobileNumber)
                }
                helperText={
                  formik?.touched?.editedNewMobileNumber &&
                  formik?.errors?.editedNewMobileNumber
                }
                className={classes.textField}
              />
            </div>
          </div>

          <div className={classes.actionsContainer}>
            <Button
              type='submit'
              className={classes.cancelButton}
              onClick={formik.handleSubmit}
              disabled={loading}
            >
              Save
            </Button>

            <Button
              className={classes.cancelButton}
              onClick={handleCancelClick}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </>
  )
}
export default ChangeMobileNumber

const useStyles = makeStyles({
  mainContainer: {
    margin: '10px',
    backgroundColor: '#fff',
    padding: '10px',
    borderRadius: '10px',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  headingContainer: {
    color: '#B92250',
    textAlign: 'center',
    justifyContent: 'center',
    height: '100% !important',
    width: '100% !important',
    fontWeight: 'bolder',
    alignItems: 'center',
  },
  formContainer: {
    height: '100% !important',
    width: '100% !important',
    fontWeight: 'bolder',
  },
  actionsContainer: {
    height: '100% !important',
    width: '100% !important',
    fontWeight: 'bolder',
    marginTop: '20px',
    gap: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cancelButton: {
    textTransform: 'unset !important',
    color: 'white !important',
    fontSize: '11px',
    fontWeight: '600',
    background: '#B92250 !important',
    height: '24px',
    padding: '17px 15px !important',
    borderRadius: '20px !important',
    '&:hover': {
      backgroundColor: '#C03861 !important',
    },
  },
  customTextField: {
    '& input::placeholder': {
      fontSize: '12px',
    },
  },
  comingSoon: {
    width: '100% !important',
    justifyContent: 'center',
    display: 'flex',
  },
  textFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    borderColor: '#B92250 !important',
  },
})
